export default "__VITE_ASSET__Bf6IDYUl__"